import React from "react";

export default function SkippedAnser({ explain }) {
  return (
    <div className="correctanswer bg-gray-200 text-black">
      <p>{explain}</p>
    </div>
  );
}
